import React from 'react'
import ELearningCourseGeneralEnroll from '../../../modules/ELearning/Course/GeneralEnroll'

const ELearningCourseGeneralEnrollPage = () => {
  return <ELearningCourseGeneralEnroll />
}

export default ELearningCourseGeneralEnrollPage
